import React, { type ReactElement, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "gatsby-plugin-react-i18next";

import DevicesModal from "@components/devices_modal";

const HowItWorks = (): ReactElement => {
  const { t } = useTranslation();
  const [isCheckCompatibilityModalOpen, setIsCheckCompatibilityModalOpen] =
    useState<boolean>(false);

  const isCheckCompatibilityRedirectLink: boolean = true;

  return (
    <section className="mb-10 text-center">
      <h2 className="mb-5 text-xl md:text-3xl">{t("how_bnesim_esim_works")}</h2>
      <div className="flex flex-col items-start justify-center gap-4 md:flex-row md:justify-between">
        <div className="relative flex w-full flex-col-reverse justify-center gap-2 rounded-2xl border bg-white p-3 shadow-sm md:flex-col md:border-transparent md:bg-transparent md:shadow-transparent">
          <div className="-mb-3 flex h-[195px] items-center justify-center md:mb-5">
            <StaticImage
              src="../assets/images/how_bnesim_esim_work_step_1.png"
              placeholder="none"
              loading="eager"
              height={195}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="how it works"
            />
          </div>
          <div className="flex flex-col items-center justify-center gap-2">
            <h3 className="text-lg font-semibold md:text-xl">
              {t("buy_your_esim_title")}
            </h3>
            <p className="mb-0 text-base md:text-lg">
              {t("buy_your_esim_body")}
            </p>
            <div className="flex justify-center">
              <button
                onClick={() => {
                  if (
                    isCheckCompatibilityRedirectLink &&
                    typeof window !== "undefined" &&
                    window.open &&
                    process.env.GATSBY_CHECK_COMPATIBILITY_LINK
                  ) {
                    window.open(
                      process.env.GATSBY_CHECK_COMPATIBILITY_LINK,
                      "compatibility",
                    );
                  } else {
                    setIsCheckCompatibilityModalOpen(true);
                  }
                }}
                className="custom-link-btn-primary"
              >
                <span className="underline">{t("check_compatibility")}</span>
              </button>
            </div>
          </div>
          <DevicesModal
            isModalOpen={isCheckCompatibilityModalOpen}
            setIsModalOpen={setIsCheckCompatibilityModalOpen}
          />
        </div>

        <div className="relative flex w-full flex-col-reverse justify-center gap-2 rounded-2xl border bg-white p-3 shadow-sm md:flex-col md:border-transparent md:bg-transparent md:shadow-transparent">
          <div className="-mb-3 flex h-[195px] items-center justify-center md:mb-5">
            <StaticImage
              src="../assets/images/how_bnesim_esim_work_step_2.png"
              placeholder="none"
              loading="eager"
              height={195}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="how it works"
            />
          </div>
          <div className="flex flex-col items-center justify-center gap-2">
            <h3 className="text-lg md:text-xl">
              {t("install_in_one_click_title")}
            </h3>
            <p className="text-base md:text-lg">
              {t("install_in_one_click_body")}
            </p>
          </div>
        </div>

        <div className="relative flex w-full flex-col-reverse justify-center gap-2 rounded-2xl border bg-white p-3 shadow-sm md:flex-col md:border-transparent md:bg-transparent md:shadow-transparent">
          <div className="-mb-3 flex h-[195px] items-center justify-center md:mb-5">
            <StaticImage
              src="../assets/images/how_bnesim_esim_work_step_3.png"
              placeholder="none"
              loading="eager"
              height={195}
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="how it works"
            />
          </div>
          <div className="flex flex-col items-center justify-center gap-2">
            <h3 className="text-lg md:text-xl">
              {t("connect_instantly_title")}
            </h3>
            <p className="text-base md:text-lg">
              {t("connect_instantly_body")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default HowItWorks;
